<template>
  <div class="u-wrap">
    <div class="card">
      <van-form>
        <u-picker
          v-if="typeList.length>1"
          style="margin-top: 12px"
          :required="true"
          :ifNetData="false"
          :list="typeList"
          readonly
          clickable
          v-model="model.type"
          label="身份选择"
          input-align="right"
          placeholder="请选择"
          right-icon="arrow-down"
        ></u-picker>
         <u-select
          :required="true"
          readonly
          dictCode="wtlx"
          clickable
          v-model="model.wtlx"
          label="问题类型"
          input-align="right"
          placeholder="请选择"
          right-icon="arrow-down"
        ></u-select>
        <van-cell class="xhx" title="反映内容" value="" :border="false" />
        <textarea placeholder="请输入反映内容..." class="xxnr" v-model="model.fynr"></textarea>
      </van-form>
      <van-cell title="上传图片" value="" :border="false" />
      <div class="pre-box">
        <template v-if="imgPathList.length > 0">
          <div class="pre-item" v-for="(item, index) in imgPathList" :key="index">
            <img class="pre-item-image" :src="item" @click="preImage(index, imgPathList)" />
            <div class="u-delete-icon" @click="deleteImage(index)">
              <img src="@images/delete.png" style="width: 24px; height: 24px" />
            </div>
          </div>
        </template>
        <div class="pre-item" @click="clickXc">
          <img class="pre-item-image" src="@images/gzfw/icon-pz.png" />
          <input
            @change="fileChangeImage($event)"
            type="file"
            id="upload_image"
            class="input"
            :multiple="false"
            accept="image/*"
          />
        </div>
      </div>
      <van-cell title="上传视频" value="" :border="false" />
      <div  class="pre-box">
        <template v-if="videoPathList.length > 0">
        <div v-for="(item, i) in videoPathList" :key="i" style="position: relative; display: inline-block">
          <div class="pre-item-video" >
              <video  :src="item" ></video>
              <van-icon name="play" class="play-icon" size="30" /> 
          </div>
          <div class="u-delete-icon" @click="deleteVideo(i)">
            <img src="@images/delete.png" style="width: 24px; height: 24px" />
          </div>
        </div>
        </template>
        <div class="pre-item" @click="clickPz">
          <img class="pre-item-image" src="@images/gzfw/icon-sp.png" />
          <input
            @change="fileChangeVideo($event)"
            type="file"
            id="upload_video"
            class="input"
            multiple
            accept="video/*"
          />
        </div>
      </div>
    </div>
    <div class="b-btn">
      <button class="b-button" :disabled="disable" @click="onSumbit">提交</button>
    </div>

    <smrz-pop :show="showSmrz"></smrz-pop>
  </div>
</template>

<script>
import uPicker from '@/components/page/u-picker.vue'
import uSelect from '@/components/page/u-select.vue'
import { getAction, postAction } from '@/api/manage'
import FileMixin from '@/views/common/mixins/file-mixin.js'
import OpenIdMixin from '@/views/common/mixins/openId-mixin.js'
import smrzPop from '@/views/common/smrz-pop.vue'
import wx from 'weixin-js-sdk'
import { ImagePreview } from 'vant'
import Vue from 'vue'
export default {
  mixins: [FileMixin, OpenIdMixin], // 使用mixin (在main.js注册全局组件)
  components: {
    uPicker,
    uSelect,
    smrzPop,
  },
  setup() {
    // themeVars 内的值会被转换成对应 CSS 变量
    // 比如 sliderBarHeight 会转换成 `--van-slider-bar-height`
    const themeVars = {
      cellRightIconColor: '#f00',
    }

    return {
      themeVars,
    }
  },
  data() {
    return {
      show: false,
      model: {
        name:'',
        phone:'',
        fynr:'',
        type:'',
        wtlx:'',
      },

      lxfsName: '',
      list: [],
      imgList: [],
      showSmrz: false,
      typeList:[],
    }
  },
  created() {
    this.initType();
  },
  mounted() {
    document.oncontextmenu = function (e) {
      e.preventDefault()
    }
     this.initVideo()
  },
  computed: {
    disable() {
      let disable = true
      if (this.model.type && this.model.fynr&&this.model.wtlx) {
          disable = false;
      }

      return disable
    },
  },
  methods: {
    initType(){
     let str = Vue.ls.get('sfInfo');
     let data = JSON.parse(str);
     this.typeList = data.map((obj)=>{
      let item= {title:obj.type_dictText,value:obj.type}
      return item;
     })
     if(this.typeList.length==1){
      this.model.type = this.typeList[0].value;
     }
    },
    onSumbit() {
      this.model.name = this.getSmrzData().wechatName
      this.model.phone = this.getSmrzData().phone
      if(this.imgPathList.length>0)this.model.tp = this.imgPathList.join(',')
      if(this.videoPathList.length>0)this.model.sp = this.videoPathList.join(',')
      let url = '/zhshj/ztchf/add'
   
      postAction(url, this.model).then((res) => {
        if (res.success) {
          this.$router.replace({
            name: 'success',
            params: { isBack: true },
          })
        } else {
          this.$toast(res.message)
        }
      })
    },

    preImage(index, imgList) {
      ImagePreview({
        images: imgList,
        startPosition: index,
      })
    },
  },
  beforeDestroy() {},
}
</script>

<style lang="less" scoped>
@import '../../assets/less/dialog.less';
.u-wrap {
  min-height: 100vh;
  box-sizing: border-box;
  // background-color: #f5f5f5;
  // padding-bottom: 60px;
  padding-top: 12px;
  background-image: linear-gradient(180deg, #d2e3ff 0%, #ffffff 30%);
}
.u-content-wrap {
  flex: 1;
  display: flex;
}

.card {
  background: #ffffff;
  padding: 0px 0px 16px;
  margin: 0 8px;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  overflow: hidden;
  height: auto;
  margin-bottom: 12px;
}

.xxnr {
  width: 90%;
  margin: 0 12px;
  height: 128px;
  border-radius: 5px;
  border: 1px solid #ededed;
  padding: 8px;
  font-size: 14px;
}

.tips {
  padding: 12px;
  color: #999999;
  line-height: 18px;
  font-size: 12px;
  display: flex;
}

.tip {
  flex: 1;
  margin-left: 6px;
}

.sjcl-bottom {
  height: 60px;
  width: 96%;
  background: #ffffff;
  position: fixed;
  bottom: 0px;
  padding: 0px 10px;
  align-items: center;
  justify-content: center;
  display: flex;
  box-shadow: 0px -3px 8px 0px rgba(216, 216, 216, 0.5);
  .voice-mode {
    flex: 1;
    margin-left: 10px;
    margin-right: 10px;
    height: 40px;
    font-size: 16px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(211, 211, 211, 1);
    border-radius: 5px;
    text-align: center;
    line-height: 40px;
  }
}

.b-btn {
  padding: 0 20px;
  margin-bottom: 20px;

  .b-button {
    width: 100%;
    height: 40px;
    opacity: 1;
    border: none;
    margin-top: 20px;
    color: #ffffff;
    background: #2593E1;
    border-radius: 40px
  }

  .b-button[disabled] {
    opacity: 0.48;
  }
}

.input {
  width: 80px;
  height: 80px;
  position: absolute;
  display: none;
}

.imgList .title {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  padding-left: 12px;
}

.pre-box {
  display: flex;
  align-items: center;
  background-color: white;
  /* justify-content: space-between; */
  flex-wrap: wrap;
  padding: 0px 12px;
  box-sizing: border-box;
}
.btnr {
  width: 100%;
  font-size: 14px;
  margin: 16px 0px;
}
.pre-item {
  /* flex: 0 0 48.5%; */
  border-radius: 5px;
  height: 80px;
  overflow: hidden;
  position: relative;
  /* margin-bottom: px; */
}
.u-progress {
  position: absolute;
  bottom: 5px;
  left: 4px;
  right: 4px;
  z-index: 9;
  width: auto;
}

.pre-item-image {
  width: 76px;
  height: 76px;
  border-radius: 4px;
  margin-right: 10px;
  margin-bottom: 8px;
  object-fit: cover;
}

.u-delete-icon {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 10;
  /* background-color: $u-type-error; */
  border-radius: 50px;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-p {
  padding: 12px;
}

.video-class {
  margin-right: 10px;
  margin-bottom: 10px;
}

.title {
  line-height: 30px;
}

.cssSelect {
  //这里为css选择器
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none; /*用户是否能够选中文本*/
}

.yuyin {
  width: 100px;
  height: 35px;
  background: #367eff;
  border: 1px solid rgba(211, 211, 211, 1);
  border-radius: 35px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 10px;
}
.audio {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.icon_audio_default {
  background: transparent url('~@images/iconloop.png') no-repeat 0 0;
  width: 14px;
  height: 18px;
  vertical-align: middle;
  display: inline-block;
  -webkit-background-size: 42px 18px;
  background-size: 42px 18px;
  background-position: -28px center;
}

.icon_audio_playing {
  background: transparent url('~@images/iconloop.png') no-repeat 0 0;
  width: 14px;
  height: 18px;
  vertical-align: middle;
  display: inline-block;
  -webkit-background-size: 42px 18px;
  background-size: 42px 18px;
  -webkit-animation: audio_playing 1s infinite;
  background-position: 0px center;
}

@-webkit-keyframes audio_playing {
  30% {
    background-position: 0px center;
  }

  31% {
    background-position: -14px center;
  }

  61% {
    background-position: -14px center;
  }

  61.5% {
    background-position: -28px center;
  }

  100% {
    background-position: -28px center;
  }
}

.voice-list {
  padding-left: 12px;
  padding-bottom: 12px;
}
.xhx {
  width: 100%;
  position: relative;
}
.xhx::before {
  content: '*';
  display: block;
  position: absolute;
  left: 8px;
  top: 10px;
  color: red;
}

.pre-item-video{
   width: 76px;
  height: 76px;
  border-radius: 4px;
  margin-right: 10px;
  margin-bottom: 8px;
  background: rgb(148, 146, 146);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  video{
    width: 100%;
    height: 100%;
  }

  .play-icon{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }

}
</style>
